import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "./ChangePassword.css";
import pawPrintlogo from "../../Assets/Images/Navbar/pawprint-icon.png";
import HttpCommon from "../../Utils/http-common";
import swal from "sweetalert";
import styled from "styled-components";
import FormGroup from "../../Components/Common/FormGroup";
import PasswordInput from "../../Components/Common/FormGroup/PasswordInput";

const ChangePassword = () => {
  const queryParameters = new URLSearchParams(window.location.search);
  const id = queryParameters.get("id");
  const token = queryParameters.get("token");
  const navigate = useNavigate();
  const [newPasswordShown, setNewPasswordShown] = useState(false);
  const [conPasswordShown, setConPasswordShown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Validation schema using Yup
  const validationSchema = Yup.object({
    newPassword: Yup.string()
      .min(6, "Password must be at least 6 characters long")
      .matches(/[A-Z]/, "Password must contain at least 1 uppercase letter")
      .matches(/[!@#$%^&*]/, "Password must contain at least 1 special character")
      .required("New password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('newPassword'), null], "Passwords must match")
      .required("Confirm password is required")
  });

  const initialValues = {
    newPassword: "",
    confirmPassword: ""
  };

  const handleSubmit = async (values, { setSubmitting, setErrors, resetForm }) => {
    setIsLoading(true);
    try {
      const res = await HttpCommon.post(
        `/user/forget-password/${id}/${token}`,
        values
      );
      
      if (res.status === 200) {
        window.open("/success-page", "_blank");
        window.close();
        navigate("/success-page");
      } else if (res.status === 407) {
        swal("Error!", "Email expired. Try again.", "error");
        navigate("/forget-password");
      } else if (res.status === 503) {
        swal("Error!", "Something went wrong", "error");
        navigate("/forget-password");
      } else if (res.status === 500) {
        swal("Error!", "Cannot change now. Try again later.", "error");
      }
    } catch (error) {
      console.error("Error:", error);
      setErrors({ submit: "Something went wrong. Please try again." });
    } finally {
      setIsLoading(false);
    }
  };

  const handleShowNewPassword = () => {
    setNewPasswordShown(!newPasswordShown);
  };

  const handleShowConPassword = () => {
    setConPasswordShown(!conPasswordShown);
  };

  return (
    <div className="main">
      <div className="container">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ errors,getFieldProps }) => (
            <Form>
              <div className="headerImage">
                <img src={pawPrintlogo} className="pawPrintlogo" alt="logo" />
              </div>
              <h1>Forgot Password?</h1>

              {errors.submit && <p className="error-message">{errors.submit}</p>}
              
              <FormGroup
                label="New Password"
                name="newPassword"
                className="loginField"
                svgPath={require("../../Assets/Images/lock.png")}
                requiredField
              >
                  <PasswordInput {...getFieldProps("newPassword")} />
              </FormGroup>

              <FormGroup
                label="Confirm Password"
                name="confirmPassword"
                className="loginField"
                svgPath={require("../../Assets/Images/lock.png")}
                requiredField
              >
                <PasswordInput {...getFieldProps("confirmPassword")} />
              </FormGroup>
              <button 
                type="submit" 
                className="btn1" 
                disabled={isLoading}
              >
                {isLoading ? "Changing Password..." : "Change Password"}
              </button>
              <br />
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ChangePassword;

const Image = styled.img`
  position: absolute;
  padding-top: 38px;
  right: 25px;
  width: 18px;
  height: 18px;

  @media screen and (max-width: 500px) {
    right: 70px;
  }

  @media screen and (max-width: 320px) {
    right: 90px;
  }
`;
